import { useContext, useEffect, useState } from 'react'
import TokenContext from './TokenContext'
import { confiUrl } from './tekenConfig'
import { EditForm } from './EditForm'

export const Ranks = () => {
  const token = useContext(TokenContext)
  const [rents, setRents] = useState([])
  const [selected, setSelected] = useState(null)
  const refreshData = (authToken)=>{
    if (authToken) {
      fetch(`${confiUrl.GET_MY_RENTS_URL}?token=${authToken}`).then((r) => {
        return r.json().then((j) => {
          if (j.success) {
            setRents(j.rents)
          } else {
            console.error('error getting rents', j)
          }
        })
      }).catch((err) => {
        console.log('error getting rents catch', err)
      })
    }
  }
  useEffect(() => {
    refreshData(token)
  }, [token])
  return token && <div>
    Ranks
    <div>
      <table>
        <thead>
        <tr>
          <th>#</th>
          <th>City</th>
          <th>Rent</th>
          <th>Address</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        {rents.map((item, index) => {
          return <tr key={index}>
            <th>{index + 1} </th>
            <td>{item.City__c}</td>
            <td>{item.Rent_price_monthly__c} $</td>
            <td>{item.Street_name__c} {item.Street_number__c}</td>
            <td>
              <button onClick={()=> setSelected(item)}>edit 📜</button>
            </td>
          </tr>
        })
        }
        </tbody>
      </table>
    </div>
    <button onClick={()=> setSelected({})}>Add New</button>
    {selected && <EditForm initialValues={selected} afterSave={() => {
      refreshData(token)
      setSelected(null)
      console.log('afterSave')
    }}/>}

  </div>
}